<ui-modal [modalTitle]="title" size="lg">

	<div class="input-group mb-2">
		<span class="input-group-prepend"><span class="input-group-text"><i class="wq wq-search"></i></span></span>
		<input type="search" class="form-control" placeholder="Search" [(ngModel)]="search" autocomplete="chrome-off" spellcheck="false" appDesktopFocus>
	</div>

	<div style="height: 600px;" class="scrollable mb-2">
		<table class="table table-hover">
			<thead>
				<tr>
					<th>Name</th>
					<th class="text-center"></th>
					<th>Location</th>
					<th *ngIf="showPoCount" class="text-center nowrap shrink">Active POs</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let item of list | keywords:search:['id', 'name', 'posttown', 'postcode', 'vendor_number', 'account_number'] | pagination:pagination" class="selectable" [ngClass]="{'table-success': item.id === selected?.id }" (click)="selectItem(item)">
					<td>
						<b>{{item.name}}</b>
						<div *ngIf="item.is_supplier && item.vendor_number" class="text-secondary small">Vendor No: {{item.vendor_number}}</div>
						<div *ngIf="item.is_supplier && item.account_number" class="text-secondary small">Account No: {{item.account_number}}</div>
					</td>
					<td class="text-center">
						<span *ngIf="item.for_organisation && !item.from_catalogue" class="badge badge-info ml-2">This Organisation</span>
						<span *ngIf="item.from_catalogue" class="badge badge-info ml-2">From Catalogue</span>
					</td>
					<td>{{item.posttown}} <small>{{item.postcode}}</small></td>
					<td *ngIf="showPoCount" class="text-center shrink">
						<span class="badge bg-dark-15 p-2">{{item.po_count || 0}}</span>
					</td>
				</tr>
				<tr *ngIf="!pagination.count">
					<td [attr.colspan]="showPoCount ? 4 : 3" class="text-secondary">No entities found.</td>
				</tr>
			</tbody>
		</table>
	</div>

	<app-pagination [pagination]="pagination"></app-pagination>

	<button *ngIf="isSupplier || isManufacturer" class="btn btn-success" (click)="addEntity()" ui-modal-footer><i class="wq wq-add mr-2"></i>Add {{ isSupplier ? 'supplier' : 'manufacturer' }}</button>
	<div class="flex-weight-1" ui-modal-footer></div>
	<button class="btn btn-secondary" (click)="modal.close()" ui-modal-footer>Cancel</button>
	<button *ngIf="mode === 'procure' && !po_type" [disabled]="!selected" class="btn btn-info ml-2" (click)="addTo('project')" ui-modal-footer><i class="wq wq-booking-project mr-1"></i> Add to Project PO</button>
	<button *ngIf="mode === 'procure' && !po_type" [disabled]="!selected" class="btn btn-danger ml-2" (click)="addTo('combined')" ui-modal-footer><i class="wq wq-combine mr-1"></i>Add to Combined PO</button>

</ui-modal>

<ng-template modalEditEntity></ng-template>
